import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface TypeTestStore {
  typeResultFrom: 'chat' | 'my' | 'home'
  setTypeResultFrom: (from: 'chat' | 'my' | 'home') => void
}

export const useTypeTestStore = create(
  persist<TypeTestStore>(
    set => ({
      typeResultFrom: 'my',
      setTypeResultFrom: (typeResultFrom: 'chat' | 'my' | 'home') => set({ typeResultFrom })
    }),
    { name: 'typeTestStorage', storage: createJSONStorage(() => sessionStorage) }
  )
)
